import { sharedAtom } from '../utilities/jotai-utils';

export const globalSearchOpenState = sharedAtom('globalSearchOpenState', false);

export const globalSearchPendingTextState = sharedAtom('globalSearchPendingTextState', '');
